module.exports = __webpack_public_path__ + "img/avatar-02-140x140.8eebf619.png";